import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from '../styles/shared-styles';
import { MobxLitElement } from '@adobe/lit-mobx';
import { Album, libraryStore } from '../stores/libraryStore';
import { playbackStore } from '../stores/playbackStore';

@customElement('app-nav')
export class AppNav extends MobxLitElement {
  static styles = [styles, css`
    :host {
      display: block;
    }

    #root {
      height: 100%;
      background: var(--bg-color);
      padding: 24px 18px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .library-section {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .library-section h2 {
      margin: 0;
      font-size: 18px;
      color: var(--text-color, #1f1f1f);
      font-weight: 600;
    }

    .hint {
      margin: 0;
      font-size: 13px;
      color: var(--text-color-secondary, #666);
      line-height: 1.5;
    }

    dl {
      margin: 0;
      display: grid;
      gap: 10px;
      font-size: 13px;
      color: var(--text-color-secondary, #666);
    }

    dt {
      font-weight: 600;
      color: var(--text-color, #1f1f1f);
    }

    dd {
      margin: 0;
      word-break: break-word;
    }

    .status {
      font-size: 12px;
      color: var(--accent-color, #007acc);
      font-style: italic;
    }

    .artist-group {
      h2 {
        text-transform: uppercase;
        font-size: 14px;
        margin: 16px 4px 8px 4px;
        color: var(--text-color, #1f1f1f);
        font-weight: 600;
      }
      h3 {
        cursor: pointer;
        font-size: 12px;
        padding: 8px 4px 4px 4px;
        margin: 0;
        color: var(--text-color, #1f1f1f);
        font-weight: 400;

        &:hover {
          background: var(--hover-bg-color, #f0f0f0);
        }
      }
    }
  `];

  render() {
    const collection = libraryStore.collection;

    return html`
      <div id="root">
        ${collection.artists.map(artist => html`
          <div class="artist-group">
            <h2>${artist.name}</h2>
            ${artist.albums.map(album => html`<h3 @click=${() => this.handleAlbumClick(album)}>${album.title}</h3>`)}
          </div>
        `)}
      </div>
    `;
  }

  private handleAlbumClick(album: Album) {
    playbackStore.playAlbum(album.tracks);
  }
}
